import React from 'react';
import ThemeToursTemplate from './ThemeToursTemplate';

const AdventureTours = () => {
  return <ThemeToursTemplate theme="adventure" />;
};

export default AdventureTours;
